import {
    hotelItemTracking,
    trackImpressionProductClick,
} from 'component/Accommodation/Recommender/__helper/trackData';
// import {
//     TRACKING_CATEGORY,
//     TRACKING_OPEN_LAYER_CLICK_RATING_RECOMMENDERS,
// } from 'component/Accommodation/Recommender/constant';
import { TrackingLabels } from 'component/Accommodation/Recommender/types';

// import trackingEvent from 'utility/Track/trackingHelper';

export const trackProductClick = (
    hotelItem: hotelItemTracking,
    index: number
): void => {
    trackImpressionProductClick(hotelItem, index, TrackingLabels.BOTTOM);
    // TODO: might need this for seo indexing
    // trackingEvent({
    //     category: TRACKING_CATEGORY,
    //     label: `${hotelItem.masterData?.id ?? 0}`,
    //     action: TRACKING_OPEN_LAYER_CLICK_RATING_RECOMMENDERS,
    // });
};

export const trackProductClickTop = (
    hotelItem: hotelItemTracking,
    index: number
): void => {
    trackImpressionProductClick(hotelItem, index, TrackingLabels.TOP);
    // TODO: might need this for seo indexing
    // trackingEvent({
    //     category: TRACKING_CATEGORY,
    //     label: `${hotelItem.masterData?.id ?? 0}`,
    //     action: TRACKING_OPEN_LAYER_CLICK_RATING_RECOMMENDERS,
    // });
};
